import { SModel } from "servisofts-model";
import Action from "./Action";
import Reducer from "./Reducer";

export default new SModel<Action, Reducer>({
    info: {
        component: "servicio"
    },
    Columns: {
        "key": { type: "text", pk: true },
        "descripcion": { type: "text", editable: true },
        "fecha_on": { type: "timestamp", label: "Fecha de registro" },
        "estado": { type: "integer" },
        "estado_app": { type: "integer", editable: true },
        // "key_usuario": { type: "text", fk: "usuario" },

    },
    image: {
        api: "root",
        name: "servicio"
    },
    Action,
    Reducer,
});